import GeneralFilter from '../../../../Model/GeneralFilter'

export default class AboutUsFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
